export const getUser = state => state.user;
export const getLoading = state => state.loading;
export const getSelectProject = state => state.selectProject;
export const getProgress = state => state.progress;
export const getProgressArray = state => state.progressArray;



// WEBPACK FOOTER //
// ./src/store/getters.js